import { useStringTranslation } from "../useStringTranslation";
import { LanguageInterface } from "../../interfaces/shared/LanguageInterface";
import { ProductDetailInterface } from "../../interfaces/apiV2/product/ProductDetailInterface";

interface UseProductGeneralInformationParams {
    data?: ProductDetailInterface;
    activeLanguage: LanguageInterface | null;
    loading: boolean;
}

interface UseProductGeneralInformationReturn {
    showSkeleton: boolean;
    hasContent: boolean;
    cardTitle: string;
    descriptionHtml: string | undefined;
}

export const useProductGeneralInformation = ({
    data,
    activeLanguage,
    loading,
}: UseProductGeneralInformationParams): UseProductGeneralInformationReturn => {
    const {
        t,
        translations,
        isLoading: isTranslationsLoading,
        isFetching: isTranslationsFetching,
    } = useStringTranslation();
    const isTranslationsPending =
        isTranslationsLoading || (isTranslationsFetching && !translations);
    const translationsLoaded =
        !!translations && !!activeLanguage && !isTranslationsPending;

    const descriptionHtml = data?.description?.value ?? undefined;
    const hasContent = !!descriptionHtml;
    const showSkeleton = loading || !translationsLoaded;

    const cardTitle = t("general-information");

    return {
        showSkeleton,
        hasContent,
        cardTitle,
        descriptionHtml,
    };
};
